import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import style from './footer.sass'

class Footer extends Component {
  render() {
    const year = new Date().getFullYear()
    return(
      <footer styleName='footer' className='landing-container'>
        <span styleName='copy'>Algoriz © {year}. All rights reserved</span>
        -
        <Link to='privacy-policy'>Privacy Policy</Link>
        -
        <Link to='terms-and-conditions'>Terms &amp; Conditions</Link>
      </footer>
    )
  }
}

export default Footer
